import React from 'react';
import { Navbar, Image } from 'react-bootstrap';
import { Nav } from 'react-bootstrap';
import { NavItem } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';

import './AppNavbar.css';
import logo from '../../assets/images/app_logo.png';

export class AppInspectorNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  isNavItemActive(name) {
    return this.props.history.location.pathname === name;
  }

  navigate(path) {
    this.props.history.push(path);
  }

  render() {
    const { t } = this.props;
    return (
      <Navbar
        className={
          'navbar navbar-default navbar-fixed-top col-sm-3 col-md-2' +
          (this.props.isShow ? '' : ' hide')
        }
      >
        <Navbar.Header>
          <Navbar.Brand>
            <Image style={{ objectFit: 'contain', padding: 6 }} src={logo} />
          </Navbar.Brand>
          <Navbar.Toggle
            data-toggle="collapse"
            data-target="#main-navigation"
          />
        </Navbar.Header>
        <Navbar.Collapse id="main-navigation">
          <Nav className="nav nav-pills nav-stacked">
            <NavItem
              eventKey={1}
              active={this.isNavItemActive('/inspection_dashboard')}
              onClick={() => this.navigate('/inspection_dashboard')}
            >
              <i className="fas fa-tachometer-alt" /> {t('dashboard')}
            </NavItem>
            <NavItem
              eventKey={1}
              active={this.isNavItemActive('/statistics')}
              onClick={() => this.navigate('/statistics')}
            >
              <i className="fas fa-chart-pie" /> {t('statistics')}
            </NavItem>
            <NavItem
              eventKey={2}
              active={this.isNavItemActive('/project_inspections')}
              onClick={() => this.navigate('/project_inspections')}
            >
              <i className="fas fa-folder" />{t('projects')}
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default translate('translations')(
  withRouter(props => <AppInspectorNavbar {...props} />),
);



// WEBPACK FOOTER //
// ./src/components/appnavbar/AppInspectorNavbar.js